import { Establishment } from "../../interface/interface";

/**
 * Establecimiento a preseleccionar en las altas de Locaciones: el preferido del usuario (Mi perfil o puesto abierto),
 * solo si está activo y figura entre las opciones del combo. Si no, ninguno.
 */
export function findPreferredEstablishment(options: Establishment[], preferredBuildingId: number | null | undefined): Establishment | null {
    if (preferredBuildingId == null) return null;
    return (options ?? []).find(est => est.buildingid === preferredBuildingId && est.active) ?? null;
}
